import { BaseApi } from "@/api/index";

const baseUrl = process.env.REACT_APP_SUPER_ADMIN_URL || "";

export interface ScientificResearch {
  id: number;
  file: string;
  title: string;
  description: string;
  folder: number;
}

export interface ScientificResearchFolder {
  id: number;
  name: string;
}

class ScientificResearchApi<T = unknown> extends BaseApi<T> {
  constructor() {
    super({
      apiBaseUrl: baseUrl,
      base: "api/scientific_researches",
    });
  }
}

class ScientificResearchFolderApi<T = unknown> extends BaseApi<T> {
  constructor() {
    super({
      apiBaseUrl: baseUrl,
      base: "api/scientific_research_folders",
    });
  }
}

export const scientificResearchApi =
  new ScientificResearchApi<ScientificResearch>();
export const scientificResearchFolderApi =
  new ScientificResearchFolderApi<ScientificResearchFolder>();
